(function ($) {
	// On Dom Ready
	$(function () {
		// Toggle sub menu
		$(
			".mobile-menu-wrapper .menu-content .primary-menu>li .menu-item-wrapper>.toggle-sub-menu"
		).on("click", function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(this).parent().next().slideToggle();
		});

		// Toggle mobile menu
		$(".menu-open").on("click", function (e) {
			e.preventDefault();
			openMenu();
		});

		$(".menu-close").on("click", function (e) {
			e.preventDefault();
			closeMenu();
		});
		
		$(document).on('keydown', function(event) {
			if (event.key == "Escape") {
				closeMenu();
			}
		});

		// Close menu when clicked outside
		$(document).on("click", function (e) {
			var $target = $(e.target);

			if (
				(!$target.closest(".mobile-menu-wrapper").length &&
					!$target.hasClass("menu-open") &&
					!$target.hasClass("fa-bars")) ||
				$target.hasClass("body-overlay")
			) {
				closeMenu();
			}
		});

		$(document).on( "focusin", function(e) {
			var $target = $(e.target);
			if (
				(!$target.closest(".mobile-menu-wrapper").length &&
					!$target.hasClass("menu-open") &&
					!$target.hasClass("fa-bars")) ||
				$target.hasClass("body-overlay")
			) {
				closeMenu();
			}

		});

		function openMenu() {
			//$("body").addClass("no-scroll");
			$(".menu-wrapper").append('<div class="body-overlay"></div>');
			$(".mobile-menu-wrapper").addClass("active");
			//$(".mobile-menu-wrapper .menu-header .searchform-mobile input[type=search]").focus();
		}

		function closeMenu() {
			//$("body").removeClass("no-scroll");
			$(".body-overlay").remove();
			$(".mobile-menu-wrapper").removeClass("active");
		}

		// toggle search dropdown on textbox focus.
		$(".searchform-mobile input").on("focus", function () {
			$(".searchform-mobile .search-dropdown-wrapper").addClass("active");
		});
		$(".searchform-mobile input").on("blur", function () {
			$(".searchform-mobile .search-dropdown-wrapper").removeClass("active");
		});

		window.addEventListener('pageshow', (event) => {
		if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
				closeMenu();
			}
		});

	});
})(jQuery);
